import React from 'react'
import './PostLoading.css';

export const PostLoading = () => {
    return (
        <div className='post-loading' data-testid="post-loading">
            
        </div>
    )
}